<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <a-card>
        <div slot="title" class="row mt-2">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-2 mb-3">
            <strong>Export All Form</strong>
            <a-button class="btn btn-outline-dark btn-lg ml-3" style="width: 150px" @click="req" :loading="onloading">Start Export All</a-button>
          </div>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import * as lou from '@/services/data/lou'
export default {
  data() {
    return {
      onloading: false,
    }
  },
  methods: {
    async req() {
      this.onloading = true
      await lou.getZip('master/exportzip')
      this.onloading = false
    },
  },
}
</script>

<style>

</style>
